import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import t from 'app/utils/translate';
import IconWatermark from 'app/components/friends/common/IconWatermark';
import GroupDetailsTitle from './GroupDetailsTitle';


type Props = {
  classes: Object,
  groupId?: number | string,
  numMembers?: number,
  numTheyRequests?: number,
  numYouRequests?: number,
  name?: string,
  children?: any,
  temporary?: boolean,
  className?: string,
};

type State = {};


class GroupDetails extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    numMembers: undefined,
    numTheyRequests: 0,
    numYouRequests: 0,
    isEditing: false,
    temporary: false,
    groupId: undefined,
    children: undefined,
    className: undefined,
    name: undefined,
  };

  render() {
    const {
      classes,
      name,
      numMembers,
      numTheyRequests,
      numYouRequests,
      children,
      temporary,
      className,
    } = this.props;

    // find the title element, otherwise default it
    let title = React.Children.toArray(children).find(child => child.type === GroupDetailsTitle);
    if (!title) {
      title = <GroupDetailsTitle>{name}</GroupDetailsTitle>;
    }

    return (
      <div className={classNames(classes.content, className, { temporary })}>
        {title}
        <div className={classes.subHeadings}>
          {numYouRequests > 0 &&
            <span className={classes.youRequests}>
              {`${numYouRequests} ${t('Pending')}`}
            </span>}
          {numTheyRequests > 0 &&
            <span className={classes.theyRequests}>
              {`${numTheyRequests} ${numTheyRequests > 1 ? t('Requests') : t('Request')}`}
            </span>}
          {numMembers !== null &&
            <span className={classes.members}>
              {numMembers !== undefined && (
                `${numMembers} ${numMembers > 1 ? t('Members') : t('Member')}`
              )}
            </span>}
        </div>
        <IconWatermark icon="icon-group" size="40%" className={classes.groupIcon} />
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    content: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      backgroundColor: theme.color.white,
      transition: 'background-color 0.2s',
      borderRadius: 8,
      position: 'relative',
      color: theme.color.basis2,
      padding: [8, 12],
      overflow: 'hidden',
      fontSmoothing: 'antialiased',
      [theme.mediaQuery.desktopAndUp]: {
        padding: [10, 20, 15, 20],
      },
      '&.temporary': {
        color: theme.color.basis4,
        background: 'transparent',
        border: {
          style: 'solid',
          width: 2,
          color: theme.color.basis4,
        },
        '& $members': {
          color: theme.color.basis4,
        },
        '& $groupIcon': {
          color: theme.color.basis4,
        },
      },
    },
    groupIcon: {
      transform: 'translateY(8%)',
      color: theme.color.basis6,
    },
    name: {
      fontSize: 18,
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: 'right',
      fontWeight: 600,
      textTransform: 'uppercase',
      zIndex: 1,
    },
    subHeadings: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'right',
      fontSize: 12,
      alignSelf: 'flex-end',
      fontWeight: 600,
      [theme.mediaQuery.desktopAndUp]: {
        fontSize: 14,
      },
    },
    members: {
      '& > svg': {
        fontSize: 10,
        marginRight: 5,
        paddingBottom: 1,
      },
      color: theme.color.primary,
    },
    theyRequests: {
      '& > svg': {
        fontSize: 11,
        marginRight: 5,
        paddingBottom: 1,
      },
      color: theme.color.primary,
    },
    youRequests: {
      '& > svg': {
        fontSize: 11,
        marginRight: 5,
        paddingBottom: 1,
      },
      color: theme.color.basis4,
    },
  };
}


export default useSheet(applyStyles)(GroupDetails);
